import React from 'react';

interface LogoProps {
  variant?: 'dark' | 'light';
  size?: 16 | 32 | 48 | 64 | 128 | 256 | 400 | 512;
  className?: string;
  alt?: string;
  format?: 'svg' | 'png';
}

export const Logo = ({ 
  variant = 'dark', 
  size = 64, 
  className = '',
  alt = 'Memara Logo',
  format = 'svg'
}: LogoProps) => {
  const logoPath = format === 'svg' 
    ? `/logos/memara-logo-${variant}.svg`
    : `/logos/${variant}/memara_logo_${size}x${size}.png`;
  
  return (
    <img
      src={logoPath}
      alt={alt}
      width={size}
      height={size}
      className={className}
      style={{ width: size, height: size }}
    />
  );
};

type LogoSize = 'sm' | 'md' | 'lg' | 'xl';

interface LogoTextProps {
  variant?: 'dark' | 'light';
  size?: LogoSize;
  className?: string;
  showIcon?: boolean;
  iconSize?: 16 | 32 | 48 | 64;
}

export const LogoText = React.forwardRef<HTMLDivElement, LogoTextProps>(({
  variant = 'dark',
  size = 'md',
  className = '',
  showIcon = true,
  iconSize = 32
}, ref) => {
  const sizeClasses: Record<LogoSize, string> = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-3xl'
  };

  const textColor = variant === 'dark' 
    ? 'text-gray-900' 
    : 'text-white';

  return (
    <div ref={ref} className={`flex items-center gap-2 ${className}`}>
      {showIcon && (
        <Logo 
          variant={variant} 
          size={iconSize} 
          format="svg"
          className="flex-shrink-0"
        />
      )}
      <span className={`font-semibold ${sizeClasses[size]} ${textColor}`}>
        Memara
      </span>
    </div>
  );
});

LogoText.displayName = 'LogoText';

export default Logo; 